module.exports = __webpack_public_path__ + "static/img/product_01.5f34c45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_01.jpg
// module id = ddh7
// module chunks = 2